import React from 'react';

/** Neutral muted-waveform badge: the recording processed fine but contained no speech. */
export const NoConversationTag = ({ iconOnly = false }: { iconOnly?: boolean }) => (
  <span className={`no-conversation-tag${iconOnly ? ' icon-only' : ''}`}
    role="img" aria-label="No conversation present" title="No speech detected in this recording.">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" role="presentation" focusable="false">
      <path d="M4 12h2M9 9v6M14 7v10M19 10v4" opacity="0.4" />
      <path d="M3 3l18 18" />
    </svg>
    {!iconOnly && <span>No conversation present</span>}
  </span>
);
